"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claims = void 0;
exports.claims = {
    canAccessExternalTasks: 'can_access_external_tasks',
    canDeleteProcessModel: 'can_delete_process_model',
    canManageProcessInstances: 'can_manage_process_instances',
    canReadCronjobHistory: 'can_read_cronjob_history',
    canReadProcessModel: 'can_read_process_model',
    canRetryProcessInstance: 'can_retry_process_instance',
    canSubscribeToEvents: 'can_subscribe_to_events',
    canTerminateProcess: 'can_terminate_process',
    canTriggerMessages: 'can_trigger_messages',
    canTriggerSignals: 'can_trigger_signals',
    canWriteProcessModel: 'can_write_process_model',
};
//# sourceMappingURL=Claims.js.map